import AsyncStorage from "@react-native-async-storage/async-storage";

const STORAGE_KEY_PREFIX = "@schoolme/android-composer-return/v1/";

export type NativeComposerReturnKind = "image" | "camera" | "document";

function storageKey(uid: string) {
  return `${STORAGE_KEY_PREFIX}${encodeURIComponent(uid)}`;
}

export function markNativeComposerReturn(uid: string, kind: NativeComposerReturnKind) {
  return AsyncStorage.setItem(storageKey(uid), kind);
}

export function clearNativeComposerReturn(uid: string) {
  return AsyncStorage.removeItem(storageKey(uid));
}

export async function consumeNativeComposerReturn(uid: string): Promise<NativeComposerReturnKind | null> {
  const key = storageKey(uid);
  const value = await AsyncStorage.getItem(key);
  await AsyncStorage.removeItem(key);
  return value === "image" || value === "camera" || value === "document" ? value : null;
}
